import { put, takeEvery, call } from 'redux-saga/effects';
import Axios from 'axios';
import { message } from 'antd';
import moment from 'moment';

import Actions from '../action';
import { appConstant, apiUrl } from '@constants';
import { setStartDate, getKeyAndToken } from '@helpers';

const dateFormat = 'MM/DD/YYYY';
const thisWeekValue = {
	startDate: moment(setStartDate('THIS_WEEK')).format(dateFormat),
	endDate: moment(new Date()).format(dateFormat),
};

export function* commissionProfilesWorker() {
	const { authKey, authToken } = yield getKeyAndToken();
	try {
		const uri = `${appConstant.domain + apiUrl.GET_AFFILIATE_BY_ID_COMMISSION_PROFILE}${authKey}&authKey=${authKey}`;
		const res = yield call(Axios.get, uri, { headers: { Authorization: authToken } });
		yield put(Actions.creators.getCommissionProfileSuccess(res.data.messages.message));
	} catch (err) {
		let mes = 'Something went wrong';
		message.error(mes);
		yield put(Actions.creators.getCommissionProfileFail());
	}
}

export default function* commissionProfilesWatcher() {
	yield takeEvery(Actions.types.GET_COMMISSION_PROFILE, commissionProfilesWorker);
}
